export default __webpack_public_path__ + "static/media/storageUnit1-afterA-480w.b74def5b.png";